import { label as vocabulary } from "./labels.js";

const node = (tag, text, className) => {
  const value = document.createElement(tag);
  if (text !== undefined) value.textContent = text;
  if (className) value.className = className;
  return value;
};

export function codingResultSummary(run) {
  const commands = (run.items || []).filter((item) => item.command);
  const passed = commands.filter((item) => item.exitCode === 0).length;
  const failed = commands.filter(
    (item) => typeof item.exitCode === "number" && item.exitCode !== 0,
  ).length;
  return {
    changedFiles: run.review?.files?.length || 0,
    commands: commands.length,
    passed,
    failed,
    unconfirmed: commands.length - passed - failed,
    review: run.reviewer?.status || "Not reviewed",
  };
}

export function createResultCard(artifact) {
  const card = node("section", undefined, "result-card");
  card.setAttribute("aria-label", "Deliverable result");
  const status =
    (artifact.review?.decision &&
      vocabulary("review", artifact.review.decision)) ||
    "Awaiting review";
  card.append(
    node("header", `Deliverable · ${status}`, "result-card-heading"),
    node("p", artifact.summary),
  );
  if (artifact.changedFiles?.length)
    card.append(
      node(
        "p",
        `${artifact.changedFiles.length} changed file${artifact.changedFiles.length === 1 ? "" : "s"}: ${artifact.changedFiles.join(", ")}`,
        "result-card-files",
      ),
    );
  const checks = artifact.evidence || [];
  card.append(
    node(
      "p",
      checks.length
        ? `${checks.length} author-reported check${checks.length === 1 ? "" : "s"}. Inspect evidence before accepting.`
        : "No checks reported.",
      "muted",
    ),
  );
  const details = node("details"),
    summary = node("summary", "Evidence and revision");
  details.append(summary, node("code", artifact.artifactRevision || ""));
  for (const check of checks)
    details.append(
      node(
        "p",
        `${check.kind} · ${check.label} · ${check.result}: ${check.detail || ""}`,
      ),
    );
  if (artifact.limitations)
    details.append(node("p", `Limitations: ${artifact.limitations}`));
  if (artifact.review)
    details.append(
      node(
        "p",
        `Human review: ${artifact.review.note || artifact.review.decision}`,
      ),
    );
  card.append(details);
  return card;
}

export function createCodingResultCard(run) {
  const data = codingResultSummary(run),
    card = node("section", undefined, "result-card");
  card.setAttribute("aria-label", "Coding result");
  card.append(
    node(
      "header",
      `Coding result · ${vocabulary("runStatus", run.status)}`,
      "result-card-heading",
    ),
    node(
      "p",
      `${data.changedFiles} changed files · ${data.commands} recorded commands`,
    ),
    node(
      "p",
      `${data.passed} exited successfully · ${data.failed} failed · ${data.unconfirmed} without a confirmed exit`,
      "muted",
    ),
    node(
      "p",
      `Independent review: ${vocabulary("review", data.review)}. ${run.status === "applied" ? "Changes applied." : "Review the frozen diff and receipts before applying changes."}`,
    ),
  );
  return card;
}
